import { render } from "./B2bTableLinesDeliveryNotesEmit.vue?vue&type=template&id=1799bf86&scoped=true&lang=pug"
import script from "./B2bTableLinesDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableLinesDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bTableLinesDeliveryNotesEmit.vue?vue&type=style&index=0&id=1799bf86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1799bf86"]])

export default __exports__